window.initEmptyCartCarousel = function() {
  const carouselWrapper = document.querySelector('.empty-cart__carousel-container');
  if (!carouselWrapper) {
    return;
  }

  // 1. Read all the dynamic data from the data-* attributes
  const {
    collectionHandle,
    sectionId,
    currencyCode,
    addToCartText,
  } = carouselWrapper.dataset;

  // 2. Find the other required elements
  const carouselContainer = carouselWrapper.querySelector('.empty-cart__carousel');
  const nextButton = carouselWrapper.querySelector('.empty-cart__carousel-nav.next');
  const prevButton = carouselWrapper.querySelector('.empty-cart__carousel-nav.prev');
  
  const fallbackSectionId = sectionId.split('__')[0];

  if (!collectionHandle || !carouselContainer) {
    if (carouselWrapper) carouselWrapper.style.display = 'none';
    return;
  }

  // 3. Fetch products from the specified collection
  fetch(`/collections/${collectionHandle}/products.json?limit=5`)
    .then(response => {
      if (!response.ok) throw new Error('Failed to fetch collection');
      return response.json();
    })
    .then(data => {
      if (!data.products || data.products.length === 0) {
        if (carouselWrapper) carouselWrapper.style.display = 'none';
        return;
      }

      const products = data.products;
      carouselContainer.innerHTML = '';

      // 4. Build HTML for each product slide
      products.forEach(product => {
        const firstVariant = product.variants[0];
        
        // Use the currencyCode from the data attribute
        const price = new Intl.NumberFormat(currencyCode, {
          style: 'currency',
          currency: currencyCode,
        }).format(firstVariant.price);
        
        let comparePriceHtml = '';
        if (firstVariant.compare_at_price > firstVariant.price) {
          const comparePrice = new Intl.NumberFormat(currencyCode, {
            style: 'currency',
            currency: currencyCode,
          }).format(firstVariant.compare_at_price);
          comparePriceHtml = `<span class="empty-cart__product-compare-price">${comparePrice}</span>`;
        }

        const imageSrc = product.images[0] ? product.images[0].src : null;
        const imageUrl = imageSrc
          ? imageSrc.replace(/(\.jpg|\.png|\.gif|\.jpeg)/, '_100x100$1')
          : null;
        
        const altText = product.images[0] && product.images[0].alt
          ? product.images[0].alt.replace(/"/g, '&quot;')
          : (product.title ? product.title.replace(/"/g, '&quot;') : 'Product image');


        const imageHtml = imageUrl
          ? `<img src="${imageUrl}" alt="${altText}" class="empty-cart__product-image" loading="lazy" width="96" height="96">`
          : `<div class="empty-cart__product-image empty-cart__product-image--placeholder"></div>`;

        const addButtonHtml = `
          <form method="post" action="/cart/add" accept-charset="UTF-8" enctype="multipart/form-data">
            <input type="hidden" name="id" value="${firstVariant.id}">
            <input type="hidden" name="quantity" value="1">
            <button
              id="ProductSubmitButton-${fallbackSectionId}-${product.id}"
              type="submit"
              name="add"
              data-lk-component="button"
              class="lk-variant-outline lk-button-size-md button--primary empty-cart__add-button"
            >
              <svg class="empty-cart__add-button-icon" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                <line x1="12" y1="5" x2="12" y2="19"></line>
                <line x1="5" y1="12" x2="19" y2="12"></line>
              </svg>
              ${addToCartText}
            </button>
          </form>
        `;
        
        const slideHtml = `
          <div class="empty-cart__carousel-slide">
            <div class="empty-cart__product-card">
              ${imageHtml}
              <div class="empty-cart__product-details">
                <h4 class="empty-cart__product-title">${product.title}</h4>
                ${firstVariant.title !== 'Default Title' ? `<div class="empty-cart__product-subtitle">${firstVariant.title}</div>` : ''}
                <div class="empty-cart__product-price-flex">
                  <span class="empty-cart__product-price">${price.split('.')[0]}</span>
                  ${comparePriceHtml.split('.')[0]}
                </div>
                ${addButtonHtml}
              </div>
            </div>
          </div>
        `;
        carouselContainer.innerHTML += slideHtml;
      });

      // 6. Initialize Carousel
      if (products.length > 1) {
        carouselWrapper.style.display = 'block'; 
        let currentIndex = 0;
        const totalSlides = products.length;

        const updateCarousel = () => {
          carouselContainer.style.transform = `translateX(-${currentIndex * 100}%)`;
          prevButton.disabled = currentIndex === 0;
          nextButton.disabled = currentIndex === totalSlides - 1;
        };

        nextButton.addEventListener('click', () => {
          if (currentIndex < totalSlides - 1) {
            currentIndex++;
            updateCarousel();
          }
        });

        prevButton.addEventListener('click', () => {
          if (currentIndex > 0) {
            currentIndex--;
            updateCarousel();
          }
        });

        updateCarousel(); 
      } else if (products.length === 1) {
        carouselWrapper.style.display = 'block';
        nextButton.style.display = 'none';
        prevButton.style.display = 'none';
      }

    })
    .catch(error => {
      console.error('Error fetching empty cart products:', error);
      if (carouselWrapper) carouselWrapper.style.display = 'none';
    });
};


document.addEventListener('DOMContentLoaded', () => {
  window.initEmptyCartCarousel();
});
